import React, {useEffect} from 'react'
import SearchResults from '../components/resultadoBusqueda/SearchResults'

const PreguntasFrecuentes = () => {
  useEffect(() => {
    document.title = "Resultado de busqueda general";  
  }, []);
  return (
    <>
    <SearchResults />
    </>
  )
}

export default PreguntasFrecuentes